module.exports = __webpack_public_path__ + "img/calendar.9f5dc706.svg";